export class RelationTagsTracking {
    // staff
    module;

    constructor() {
        this.init();
    }

    init() {
        this.module = $('.relation-tags');

        if (!this.module.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.module.on('click', 'a.lnk', (e) => {
            const button = $(e.target);

            this.sendGTMEvent({
                bloque: this.getModuleTitleText(button),
                programa: this.getProgramText(button),
                event: 'relaciones'
            });
        });
    }

    sendGTMEvent(data) {
        if (window.dataLayer) {
            console.debug('Relations event track ', data);
            window.dataLayer.push(data);
        }
    }

    // auxiliary
    getModuleTitleText(button) {
        return button.closest('.relation-tags').find('.m-title').text() || '';
    }

    getProgramText(button) {
        return button.text() || '';
    }
}

